import {Component, Input, Output, EventEmitter} from '@angular/core';

@Component({
    selector: 'app-topic-list',
    templateUrl: './topic-list.component.html',
    styleUrls: ['./topic-list.component.css']
})
export class TopicListComponent {
  @Input() topic;
  @Input() locale;

  @Output() onClick = new EventEmitter<any>();

  onTopicClick($event) {
    this.onClick.emit($event);
  }

}
